<template>
    <div class="web-box-all">
      <ext-header></ext-header>
      <div class="web-home-main">
        <div class="web-cart-top">
          <h2>
            <b>订单提交成功，请尽快付款！订单号：{{ order_no }}</b>
            <span>应付金额 <b style="color:#e31613; font-size:18px; margin:0px 5px 0px 5px;">{{pay_money}}</b> 元</span>
          </h2>
        </div>
        <div class="web-cart-list">
            <div class="web-qrcode-pay-box">
                <div class="web-qrcode-pay-top">
                    <h2>扫码支付</h2>
                </div>
                <div class="web-qrcode-pay-main">
                    <div class="web-qrcode-pay-main-left">
                        <img v-if="qr_url!=''" :src="qr_url">
                    </div>
                    <div class="web-qrcode-pay-main-right">
                        <h2>请使用以下APP手机扫码支付</h2>
                        <ul>
                            <li>
                                <img src="@/assets/icon/pay03.png"/>
                                <p>微信</p>
                            </li>
                            <li>
                                <img src="@/assets/icon/pay02.png"/>
                                <p>支付宝</p>
                            </li>
                            <li>
                                <img src="@/assets/icon/pay04.png"/>
                                <p>云闪付</p>
                            </li>
                        </ul>
                        <h3 @click="back_order_list()">
                            <img src="@/assets/icon/left_1.png"/><a>返回订单列表</a>
                        </h3>
                    </div>
                </div>
            </div>
        </div>

      </div>

      <div class="web-home-line"></div>

      <ext-footer></ext-footer>

    </div>
  </template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import {Decrypt, ajax, webUrl, getUserId, getCompanyNo} from '@/utils/extend'
import Toast from '@/components/toast/index'

export default {
  name: 'cart_list',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '购物车',
      web_url: webUrl(),
      company_no: getCompanyNo(),
      all_checked: false,
      spot_checked: false,
      stockout_checked: false,
      order_no: '',
      pay_money: '',
      qr_url: '',
      pay_event: null
    }
  },
  mounted () {
    var params = this.$route.query
    var orderNo = Decrypt(params.v)
    this.order_no = ''
    this.qr_url = webUrl() + '/store/pay/get_pay_qrcode?order_no=' + orderNo
    this.load_data(orderNo)

    // 监听订单是否支付成功
    var that = this
    this.pay_event = setInterval(function () {
      that.load_pay_state()
    }, 2000)
  },
  beforeRouteLeave (_to, _from, next) {
    var that = this
    clearInterval(that.pay_event)
    that.pay_event = null
    next()
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    back_order_list () {
      this.$router.push({path: '/order/order_list', query: {}})
    },
    load_data (orderNo) {
      var that = this
      ajax({
        url: '/store/order/order_show',
        method: 'post',
        data: {
          uid: getUserId(),
          order_no: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.order_no = ret.data.order_info.erp_order_no
          that.pay_money = ret.data.order_info.pay_money
        }
      })
    },
    load_pay_state () {
      var that = this
      if (that.order_no) {
        ajax({
          url: '/store/pay/order_pay_state',
          method: 'post',
          data: {
            uid: getUserId(),
            order_no: that.order_no
          }
        }, function (ret) {
          if (ret && ret.code === 'success') {
            clearInterval(that.pay_event)
            that.pay_event = null
            that.$router.push({path: '/order/order_list', query: {}})
          }
        })
      }
    }

  }
}
</script>
  <style scoped>
  header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
      display:-moz-box;
      display: box;
      display: -webkit-box;
      font-family: "Noto Sans SC";
      display: inline-flex;
  }

  a { text-decoration:none; }
  input { box-sizing:border-box;outline:none;}
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {-webkit-appearance: none;}
  input[type='number'] {-moz-appearance: textfield;}

  .web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
  .web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
  .web-home-line { width:100%; height:70px; }

  .web-cart-top { width:100%; height:40px; margin-top:15px; background: #ffffff; flex-flow:row; justify-content:flex-start;}
    .web-cart-top h2 { width:100%; line-height:40px; height:40px; margin:0px; padding:0px 15px; flex-flow:row; justify-content:space-between; }
    .web-cart-top h2 b { width:auto; height:40px; line-height:40px; float:left; margin:0px; padding:0px; font-size:16px; color:#d81e06; margin-right:20px; font-weight: normal;}
    .web-cart-top h2 span { font-size:14px; color:#666666;}
  .web-cart-list { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
    .web-cart-list-title { width:100%; height:40px; background: #efefef; border:1px solid #dfdfdf;}
    .web-cart-list-title.tip  {  background: #ffffff; border:0px; margin-top: 5px; font-weight: bold; border-bottom:3px solid #dfdfdf;}
    .web-cart-list-checkbox { width:140px; height:auto;  -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; line-height:40px; font-size:14px; color:#333333;}
    .web-cart-list-checkbox label { width:auto; height:auto; cursor: pointer; position: relative; line-height:40px; font-size:14px; color:#333333;}
    .web-cart-list-checkbox-input { width:20px; height:100%; line-height:40px; position: relative; margin:0px 10px 0px 10px; font-size:14px; color:#333333;}
    .web-cart-list-checkbox-input input { width:18px; height:18px; position: absolute; top:50%; left:1px; margin-top:-9px; padding:0px; font-size:14px; color:#333333;}
    .web-cart-list-checkbox img { width:80px; height:80px; cursor: pointer; margin:15px 0px 15px 0px;}
    .web-cart-list-goods { width:210px; height:auto; line-height:40px; font-size:14px; flex-wrap:wrap; align-content:flex-start; color:#333333;}
    .web-cart-list-goods p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
    .web-cart-list-goods a { width:100%; height:auto; line-height:20px; font-size:14px; color:#aaaaaa;}
    .web-cart-list-goods a:hover { color:#aaaaaa;}
    .web-cart-list-props {width:140px; height:auto; line-height:40px; font-size:14px; color:#333333;}
    .web-cart-list-props p { width:100%; height:auto; line-height:80px; margin-top:15px; font-size:14px; color:#333333;}
    .web-cart-list-price {width:120px; height:auto; line-height:40px; font-size:14px; color:#333333;}
    .web-cart-list-price p { width:100%; height:auto; line-height:80px; margin-top:15px; font-size:14px; color:#333333;}
    .web-cart-list-quantity { width:170px; height:auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; text-align: center;justify-content:center; line-height:40px; font-size:14px; color:#333333;}
    .web-cart-list-quantity p { width:136px; height:40px; line-height:40px; overflow: hidden; flex-flow:row; justify-content:flex-start; margin-top:35px; border:1px solid #dfdfdf;}
    .web-cart-list-quantity p a { width: 40px; height: 40px; cursor: pointer; background: #efefef; font-size:28px; color:#333333; line-height:34px; text-align: center; justify-content:center;}
    .web-cart-list-quantity p input { width: 55px; height:38px; line-height:38px; text-align: center; font-size:14px; color:#333333; border:0px; min-height: 20px;}
    .web-cart-list-sum { width:100px; height:auto; line-height:40px; font-size:14px; color:#333333;}
    .web-cart-list-sum p { width:100%; height:auto; line-height:80px; margin-top:15px; font-size:14px; color:#333333;}
    .web-cart-list-action { width:100px; height:auto; line-height:40px; text-align: center; justify-content:center; font-size:14px; color:#333333;}
    .web-cart-list-action a { width:100%; height:auto; cursor: pointer; text-align: center; justify-content:center; line-height:80px; margin-top:15px; font-size:14px; color:#333333;}

    .web-cart-list-data { width:100%; height:auto; margin-top:0px; border-left:1px solid #dfdfdf; border-bottom:1px solid #dfdfdf; border-right:1px solid #dfdfdf;}

    .web-cart-footer { width:100%; height:50px; flex-flow:row; position: relative; border:1px solid #dfdfdf; margin-top:20px; justify-content:flex-start; }
      .web-cart-footer-txt { width:auto; height:50px; margin-right:10px;}
      .web-cart-footer-txt p { width:auto; height:50px; cursor: pointer; line-height: 50px; font-size:14px; color:#666666}
      .web-cart-order { width:auto; height:50px; position: absolute; right:0px; top:0px;}
      .web-cart-order-num { width:auto; height:50px; margin-right:10px;}
        .web-cart-order-num p { width:auto; height:50px; line-height:50px; font-size:14px;}
        .web-cart-order-num p b { font-size:14px; color:#d81e06;}
      .web-cart-order-money { width:auto; height:50px; line-height:50px; font-size:14px; margin-right:10px;}
        .web-cart-order-money p { width:auto; height:50px; line-height:50px; font-size:14px;}
        .web-cart-order-money p span { width:auto; height:50px; line-height:50px; font-size:14px;color:#333333;}
        .web-cart-order-money p b { width:auto; height:50px; line-height:50px; font-size:16px;color:#d81e06;}
      .web-cart-order-button { width:100px; height:50px;}
        .web-cart-order-button a { width:100px; height:50px; cursor: pointer; color:#ffffff !important; background: #d81e06; line-height:50px; text-align: center; justify-content:center;}
        .web-cart-order-button a:hover { color:#ffffff;}

        .web-home-title { width:100%; height:50px; position: relative; flex-flow:row; justify-content:center; display: flex; margin-top:15px;}
    .web-home-title a { width:100px; height:10px; background: url('https://parts.franke.cn/static/image/line001.png') repeat-x; margin-top:22px; flex:1;}
    .web-home-title p { width:auto; padding:0px 15px; position: relative; box-sizing: border-box; height:50px; line-height: 50px; font-size:24px; color:#333333; text-align: center; justify-content:center;}
    .web-home-title p i { width:24px; height:1px; border-top:3px solid #d81e06; position: absolute; bottom:0px; left:50%; margin-left:-12px;}
    .web-home-title b { width:80px; cursor: pointer; height:50px; text-align: right; font-weight: normal; line-height:50px; font-size:14px; background: #ffffff; color:#666666; position: absolute; right: 0px; top:0px;}

  /* 商品列表 */
  .web-goods-main { width:1020px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
  .web-home-goods { width:100%; height:auto; margin-top:10px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
    .web-home-goods-list { width:255px; height:370px; position: relative; margin:5px 0px; padding:10px; border:1px solid #ffffff;}
    .web-home-goods-list.active { border:1px solid #d81e06;}
    .web-home-goods-list-data { width:233px; height:350px; cursor: pointer; border:1px solid #e7e7e7; flex-wrap:wrap; align-content:flex-start;}
    .web-home-goods-list-data.active { border:1px solid #ffffff;}
    .web-home-goods-list-data img { width:100%; height:230px; padding:10px 10px 0px 10px; object-fit: cover;}
    .web-home-goods-list-data h2 { width:223px; height:40px; display:-webkit-box;text-overflow:ellipsis; overflow:hidden; -webkit-line-clamp: 2; -webkit-box-orient:vertical; line-height:20px; margin:5px 0px; font-size:14px; color:#333333; padding:0px 10px;}
    .web-home-goods-list-data h3 { width:233px; height:20px; line-height:20px; margin:0px; font-size:14px; color:#333333; padding:0px 10px;}
    .web-home-goods-list-data p { width:233px; height:40px; padding:0px 10px; margin:0px; flex-flow:row; align-content:flex-start;}
    .web-home-goods-list-data p i { font-size:14px; margin-right:5px; margin-top:10px; font-style:normal; color:#d81e06;}
    .web-home-goods-list-data p b { font-size:22px; color:#d81e06;}
    .web-home-goods-list h4 { width:223px; height:40px; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; position: absolute; left:15px; bottom: 10px; z-index: 99; margin:0px; padding:0px 10px; flex-flow:row; align-content:flex-start;}
    .web-home-goods-list h4 b { font-size:14px; line-height:30px; float:left; font-weight: normal;}
    .web-home-goods-list h4 b.del { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
    .web-home-goods-list h4 b.num { width:44px; height:30px; overflow: hidden; border-top:1px solid #e7e7e7; border-bottom:1px solid #e7e7e7;}
    .web-home-goods-list h4 b.num input { width:44px; height:20px; margin-top:5px; text-align: center; line-height:20px; font-size:14px; color:#333333; min-height:20px; border:0px;}
    .web-home-goods-list h4 b.add { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
    .web-home-goods-list h4 b.cart { width:90px; height:30px; cursor: pointer; margin-left:8px; text-align: center; line-height:30px; background: #d81e06; font-size:13px; color:#ffffff;}

    .web-qrcode-pay-box { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start; border:1px solid #efefef; box-shadow: 0 6px 32px rgba(0, 0, 0, .13); }
    .web-qrcode-pay-top { width:100%; height:50px;}
        .web-qrcode-pay-top h2 { width:100%; height:50px; line-height: 50px; font-size:18px; color:#333333; padding-left:15px;}

    .web-qrcode-pay-main { width:100%; height:450px; padding:0px 100px; flex-flow:row; justify-content:flex-start; }
    .web-qrcode-pay-main-left { width:400px; height:auto;}
    .web-qrcode-pay-main-left img { width:360px; height:360px; margin:10px 20px;}
    .web-qrcode-pay-main-right { width:400px; height:auto; flex-wrap:wrap; align-content:flex-start;}
    .web-qrcode-pay-main-right h2 { width:100%; height:40px; line-height: 40px; font-size:15px; margin-top:50px;}
    .web-qrcode-pay-main-right ul { width:100%; height: auto; list-style: none; flex-flow:row; justify-content:flex-start;}
    .web-qrcode-pay-main-right ul li { width:60px; height:auto; display: block; flex-flow:row; justify-content:flex-start;}
    .web-qrcode-pay-main-right ul li p { width:60px; height:20px; line-height: 20px; text-align: center; font-size:14px; justify-content:center;}
    .web-qrcode-pay-main-right ul li img { width:40px; height: 40px; margin:5px 10px;}
    .web-qrcode-pay-main-right h3 { width:100%; height: 20px; cursor: pointer;flex-flow:row; justify-content:flex-start;}
    .web-qrcode-pay-main-right h3 a {  line-height: 20px; font-size: 18px; color:#67a4ff;}
    .web-qrcode-pay-main-right h3 a:hover { color:#67a4ff;}
    .web-qrcode-pay-main-right h3 b {  line-height: 20px; font-size: 24px; color:#67a4ff; font-weight: normal; margin-right:5px;}
    .web-qrcode-pay-main-right h3 img { width:20px; height:20px;}
  </style>



// WEBPACK FOOTER //
// src/pages/cart/pay_order.vue